import { combineReducers } from 'redux';
import { reducer as userReducer } from "./user/index";
import { reducer as globalReducer } from './global/index';
import { reducer as projectReducer } from './project/index';
import { reducer as systemReducer } from './system/index';
import { reducer as saleReducer } from './sale/index';
import { reducer as agentReducer } from './agent/index';
import { reducer as groupReducer } from './group/index';
import { reducer as cartReducer } from './cart/index';
import { reducer as quotationReducer } from './quotation/index';
import { reducer as offerReducer } from './offer/index';
import { reducer as productReducer} from './product/index';
import { reducer as authorizeReducer} from './authorize/index';
import { reducer as todoReducer } from './todo';
import { reducer as docReducer } from './doc';
import { reducer as faqReducer } from './faq';
import { reducer as releaseReducer } from './release';
import { reducer as tableReducer } from './table/index';
import { reducer as customerReducer } from './customer/index';
import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage/session';
import storageLocal from 'redux-persist/lib/storage';

const userPersistConfig = {
  key: 'user',
  storage: storageLocal,
  blacklist: ['loginToken', 'companyInfo']
};

const tablePersistConfig = {
  key: 'table',
  storage: storageLocal,
  blacklist: []
};

export default combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  global: globalReducer,
  project: projectReducer,
  system: systemReducer,
  sale: saleReducer,
  agent: agentReducer,
  cart: cartReducer,
  group: groupReducer,
  quotation: quotationReducer,
  offer: offerReducer,
  product: productReducer,
  authorize: authorizeReducer,
  todo: todoReducer,
  doc: docReducer,
  faq: faqReducer,
  release: releaseReducer,
  customer: customerReducer,
  table: persistReducer(tablePersistConfig, tableReducer),
});